import { useState, useEffect } from 'react'
import { apiService } from '../services/api'
import { config } from '../config/environment'
import type { Competition } from '../types'

interface ActiveCompetitionResult {
  competition: Competition | null
  albatrossCompId: string
  loading: boolean
}

/**
 * Fetches the active competition and returns its albatrossCompId.
 * Falls back to config.albatrossCompId (VITE_ALBATROSS_COMP_ID env var) if:
 * - the API call fails (e.g. non-admin user)
 * - no active competition is found
 * - the active competition has no albatrossCompId set
 */
export function useActiveCompetition(): ActiveCompetitionResult {
  const [competition, setCompetition] = useState<Competition | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    apiService.getCompetitions()
      .then((response) => {
        if (cancelled) return
        if (response.error || !response.data) {
          setLoading(false)
          return
        }
        const data = response.data as any
        const arr: Competition[] = data?.data?.competitions || data?.competitions || data?.data || []
        const active = Array.isArray(arr) ? arr.find((c) => c.isActive) ?? null : null
        setCompetition(active)
        setLoading(false)
      })
      .catch(() => {
        if (!cancelled) setLoading(false)
      })
    return () => { cancelled = true }
  }, [])

  const albatrossCompId =
    competition?.albatrossCompId || config.albatrossCompId

  return { competition, albatrossCompId, loading }
}
